const alertConstants = {
	SHOW_ALERT: "SHOW_ALERT",
	CLOSE_ALERT: "CLOSE_ALERT",
	SHOW_WILL_PAYMENT_MODAL: "SHOW_WILL_PAYMENT_MODAL",
	HIDE_WILL_PAYMENT_MODAL: "HIDE_WILL_PAYMENT_MODAL"
};

export default alertConstants;
